import { getRequest } from '@homework-studio/api-client';
import { HomeworkMetadataResponse } from '../types/metadata.type';

export const getList = async () => {
  const res = await getRequest<HomeworkMetadataResponse>('/metadata');
  return res.data;
};
